import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/certificate_types',
    name: 'CertificateType',
    component: {
      name: 'AdminCertificateType',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'certificate_type',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminCertificateTypeIndex',
        component: () => import('../views/CertificateTypeAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminCertificateTypeNew',
        component: () => import('../views/CertificateTypeAdminInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminCertificateTypeIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminCertificateTypeShow',
        component: () => import('../views/CertificateTypeAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminCertificateTypeIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminCertificateTypeDetails',
            component: () => import('../views/CertificateTypeAdminDetails.vue'),
            meta: {
              backRoute: { name: 'AdminCertificateTypeIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminCertificateTypeEdit',
            component: () => import('../views/CertificateTypeAdminInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminCertificateTypeDetails' },
            },
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));